import React from 'react';
import { PropTypes } from 'prop-types';
import { withRouter } from 'react-router';

import ErrorPage from 'components/Errors/ErrorPage';

const InternetConnectionError = () => <ErrorPage
  title="No Connection"
  type="network"
  showButton
  onButtonClick={ () => { window.location.href = '/'; } }
>
  <p>Poor or no network connectivity detected.  Please check the following:</p>
  <ul>
    <li>Airplane mode is switched off</li>
    <li>Turning on mobile data or Wi-Fi</li>
    <li>Checking the signal in your area</li>
  </ul>
</ErrorPage>;

InternetConnectionError.propTypes = {
  history: PropTypes.shape({
    go: PropTypes.func,
  }).isRequired
};

export default withRouter(InternetConnectionError);
